module.exports = __webpack_public_path__ + "static/media/iconConseilClassesActive.330fd821.svg";